// 口コミフォーム用の評価項目定義
// Phase72-ReviewForm: 評価軸を新仕様に統一

export const SITE_REVIEW_RATING_ITEMS = [
  {
    key: 'rating_place' as const, // DB カラム名（旧: rating_ibasho）
    label: 'わかりやすさ・学びやすさ',
    help: '子どもが直感的に操作できるか、説明が分かりやすいか',
  },
  {
    key: 'rating_home' as const,
    label: '自主学習のしやすさ',
    help: '子どもが一人でも進めやすいか、ヒントや例が充実しているか',
  },
  {
    key: 'rating_self' as const,
    label: '印刷・配布のしやすさ',
    help: '問題やプリントとして印刷して配りやすいか',
  },
  {
    key: 'rating_print' as const,
    label: 'デザイン・見やすさ',
    help: '文字の大きさや配色が見やすく、疲れにくいか',
  },
  {
    key: 'rating_design' as const,
    label: '独自性・価値',
    help: 'ここならではの良さや、他サイトにはない工夫があるか',
  },
] as const;

// 評価項目のキー型
export type SiteReviewRatingKey = typeof SITE_REVIEW_RATING_ITEMS[number]['key'];
